var _circle, _polygon, _rect, _rect2, _circle2, _circle3, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHenryIllustrationGlitched(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 20,
    r: 13,
    fill: "#1890ff",
    opacity: 0.22
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "84,6 73,22 79,22 76,34 87,17 81,17",
    fill: "#1890ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 28,
    width: 7,
    height: 24,
    rx: 3,
    fill: "#555555"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 54.5,
    width: 104,
    height: 73,
    rx: 17.5,
    fill: "#ffffff",
    stroke: "#555555",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 91,
    r: 5.5,
    fill: "#1890ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 91,
    r: 11,
    fill: "#1890ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 -9 Q 2 -2 9 0 Q 2 2 0 9 Q -2 2 -9 0 Q -2 -2 0 -9 Z",
    transform: "translate(32 30) scale(0.55)",
    fill: "#40a9ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 -9 Q 2 -2 9 0 Q 2 2 0 9 Q -2 2 -9 0 Q -2 -2 0 -9 Z",
    transform: "translate(120 16) scale(0.8)",
    fill: "#1890ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 -9 Q 2 -2 9 0 Q 2 2 0 9 Q -2 2 -9 0 Q -2 -2 0 -9 Z",
    transform: "translate(154 46) scale(0.6)",
    fill: "#40a9ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHenryIllustrationGlitched);
export default __webpack_public_path__ + "static/media/henry-illustration-glitched.7b858b72e2fbf058739f44f9f71fb3ce.svg";
export { ForwardRef as ReactComponent };